export default "__VITE_ASSET__fcf27df2__"